module.exports = __webpack_public_path__ + "static/media/23.99275eba.mp3";